<template>
  <div class="fullPage" style="color:#fff;">
    <div class="dx-field">
        <div class="dx-field-value">
          <DxRadioGroup
            :items="displayRows"
            :value="displayRows[0]"
            layout="horizontal"
            display-expr="label"
            @valueChanged="changeSelectionLayout"
           
          />
        </div>
      </div>
       <DocumentEditor v-for="col in numColumns" :key="'col'+col" class="docEdit" :index="col-1" :style="'width:'+Math.floor(100/numColumns)+'%'">  </DocumentEditor> 
        
 
  </div>
</template>

<script>

import DocumentEditor from '../components/DocumentEditor'
import { DxRadioGroup } from 'devextreme-vue';

export default {
  components: {
    DocumentEditor,
    DxRadioGroup
  },
  data() {
    return {
     
      numColumns:1,
      displayRows:[{label:"1 Column",numCol:1},{label:"2 Columns",numCol:2},{label:"3 Columns",numCol:3}]
         }
  },
  mounted(){
     
    },
    computed:{
      
    },
    methods:{
     changeSelectionLayout(e) {
      this.numColumns = e.value.numCol;
    }
    },
    watch:{
      
      
    },
  beforeDestroy() {
    
  },
}
</script>
<style>
.fullPage{
  height:calc(100% - 50px);
  overflow: hidden;
}

.docEdit{
   height:calc(100% - 60px);
  display:inline-flex;
  flex-direction:column; 
  overflow: hidden;
}
.docList{
   height:calc(100% - 60px);
   padding-top: 12px;
  display:inline-flex;
  flex-direction:column; 
  overflow: auto;
}


</style>